<template>
  <div class="app_menu_header">
    <span>{{ title }}</span>

    <div class="backBeforePage" @click="handleRouterBack">
      <i class="el-icon-arrow-left" />
    </div>

    <div
      class="fileBtn"
      v-if="showFileBtn"
      @click="
        () => {
          $emit('clickFileBtn')
        }
      "
    >
      附件
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showFileBtn: {
      type: Boolean,
      default: false
    },
    backPath: {
      type: String
    },
    menuArgs: {
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {
    handleRouterBack() {
      let query = {}
      if (this.menuArgs) {
        query = {
          type: 'todo'
        }
      }

      this.$router.push({
        path: this.backPath,
        query
      })
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;
.app_menu_header {
  height: @headerHeight;
  width: 100%;
  background-color: #6c9eff;
  position: relative;

  text-align: center;
  font-size: 24px;
  color: #fff;
  // line-height: @headerHeight;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  .backBeforePage {
    position: absolute;
    top: 0px;
    left: 0px;
    width: @headerHeight;
    height: @headerHeight;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fileBtn {
    position: absolute;
    top: 0px;
    right: 10px;
    width: @headerHeight;
    height: @headerHeight;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 20px;
    font-weight: 400;

    &:active {
      opacity: 0.5;
    }
  }
}
</style>
